import { createDefaultTyrann } from '@apis/common';
import { zendeskTicket } from '@models/Zendesk';
import * as t from 'io-ts';

export const zendeskApis = createDefaultTyrann({
  '/dashboard/zendesk/{d2dNo}/tickets/': {
    get: {
      path: t.type({
        d2dNo: t.string,
      }),
      response: {
        200: t.array(zendeskTicket),
        404: t.type({}),
      },
    },
  },
  '/dashboard/zendesk/{userId}/{d2dNo}/ticket/': {
    post: {
      path: t.type({
        userId: t.number,
        d2dNo: t.string,
      }),
      response: {
        200: zendeskTicket,
      },
    },
  },
});
